import React from 'react';

import CSSModule from 'react-css-modules';

import styles from './TermsOfService.module.scss';

const TERMS_OF_SERVICE_URL = process.env.REACT_APP_TERMS_OF_SERVICE_URL;

const TermsOfService = () => (
  <div styleName="page">
    <iframe title="Terms of Service" src={TERMS_OF_SERVICE_URL} styleName="frame" />
  </div>
);

export default CSSModule(TermsOfService, styles, { allowMultiple: true });
